import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';

import { get as _get } from 'lodash';

const useStyles = makeStyles(theme => ({
    root: {
    },
    rubberband: {
        position: 'absolute',
        borderStyle: 'dashed',
        borderColor: theme.palette.secondary.main,
        borderWidth: 1,
        backgroundColor: 'transparent',
    },
}));

const Rubberband = ({ onSelection, selector, slack, dakey, anchorEl, size }) => {
    const classes = useStyles();
    const rubberbandRef = useRef(null);
    const [offset, setOffset] = useState({});
    const [box, setBox] = useState({ width: 0, height: 0 });

    useEffect(() => {
        if (rubberbandRef.current) {
            const bodyRect = document.body.getBoundingClientRect();
            const elemRect = rubberbandRef.current.getBoundingClientRect();
            const parent = anchorEl || rubberbandRef.current.parentElement;
            const offset = {
                x: Math.round(elemRect.left - bodyRect.left),
                y: Math.round(elemRect.top - bodyRect.top)
            };

            const onMouseMove = e => {
                setBox(current => {
                    return {
                        ...current,
                        x1: e.pageX - offset.x,
                        y1: e.pageY - offset.y,

                        width: Math.abs(current.x0 - (e.pageX - offset.x)),
                        height: Math.abs(current.y0 - (e.pageY - offset.y)),
                        left: Math.min(current.x0, e.pageX - offset.x),
                        top: Math.min(current.y0, e.pageY - offset.y),
                    };
                });
            };

            const onMouseUp = e => {
                parent.removeEventListener('mousemove', onMouseMove);
                window.removeEventListener('mouseup', onMouseUp);
                setBox(current => ({
                    y0: e.pageY - offset.y,
                    y1: e.pageY - offset.y,
                    x0: e.pageX - offset.x,
                    x1: e.pageX - offset.x,

                    width: 0,
                    height: 0,
                }));
            };

            const onMouseDown = e => {
                if (e.which === 3 || e.button === 2) return;

                window.addEventListener('mouseup', onMouseUp);
                parent.addEventListener('mousemove', onMouseMove);
                setBox({
                    y0: e.pageY - offset.y,
                    y1: e.pageY - offset.y,
                    x0: e.pageX - offset.x,
                    x1: e.pageX - offset.x,

                    width: 0,
                    height: 0,
                    left: e.pageX - offset.x,
                    top: e.pageY - offset.y,
                });
            };
            setOffset(offset);
            parent.addEventListener('mousedown', onMouseDown);
            return () => {
                parent.removeEventListener('mousemove', onMouseMove);
                window.removeEventListener('mouseup', onMouseUp);
                parent.removeEventListener('mousedown', onMouseDown);
            };
        }
    }, [anchorEl, size]);

    useEffect(() => {
        if (rubberbandRef.current) {
            if (box.width < 1 || box.height < 1) return;
            const selectables = [...document.querySelectorAll(selector)];
            var elements = [];
            selectables.forEach(function (element) {
                var current = element.getBoundingClientRect();
                if (
                    box.left - slack <= current.left - offset.x &&
                    box.top - slack <= current.top - offset.y + window.scrollY &&
                    box.left + box.width + slack >= current.right - offset.x &&
                    box.top + box.height + slack >= current.bottom - offset.y + window.scrollY
                ) {
                    elements.push(_get(element, `dataset.${dakey}`, ''));
                }
            });
            onSelection(elements);
        }
    }, [rubberbandRef, selector, offset, dakey, onSelection, slack, box, size]);
    return (
        <div ref={rubberbandRef}
            className={classes.rubberband}
            style={{
                width: box.width,
                height: box.height,
                left: box.left,
                top: box.top,
                opacity: box.width < 1 || box.height < 1 ? 0 : 1,
            }}>
        </div>
    );
};
Rubberband.displayName = 'Rubberband';
Rubberband.propTypes = {
    // callback with list of data values matching 'dakey'
    onSelection: PropTypes.func,
    // dom selector to match for element inclusion in selection
    selector: PropTypes.string,
    // pixles outside rubberband to include in selection
    slack: PropTypes.number,
    // key name to return in onSelection. set in object data e.g. data-dakey={somevalue}
    dakey: PropTypes.string,
    // element to restrict rubberband bounds
    anchorEl: PropTypes.object,
    // tbh this is just a kicker to let the rubberband know to recalculate positions
    size: PropTypes.object,
};

export {
    Rubberband as default,
};
